
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["coveo-search-button-svg",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg","aria-label":"Search"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff"}},[_c('path',{staticClass:"coveo-magnifier-circle-svg",attrs:{"d":"M8.368 16.736C3.754 16.736 0 12.982 0 8.368S3.754 0 8.368 0s8.368 3.754 8.368 8.368-3.754 8.368-8.368 8.368m0-14.161c-3.195 0-5.793 2.599-5.793 5.793s2.599 5.793 5.793 5.793 5.793-2.599 5.793-5.793-2.599-5.793-5.793-5.793"}}),_c('path',{attrs:{"d":"M18.713 20c-.329 0-.659-.126-.91-.377l-4.552-4.551a1.286 1.286 0 111.82-1.82l4.552 4.551a1.286 1.286 0 01-.91 2.197"}})])])
          )
        }
      }
    